/* Sweet Seeker delivery estimate.
   Rebuilt from the C-EDD app's own saved settings so the output matches:
     cut-off 12:00 Melbourne
     dispatch 0-1 days, counted in CALENDAR days (app: order_ready_work_week all 7)
     transit 2-5 days, counted in BUSINESS days, Mon-Fri (app: [0,1,1,1,1,1,0])
     no public holidays
     countdown shows hours and minutes only (app: countdown format 15)
     dates formatted "Sep 22" (app: {month_local} {day}) */
(function () {
  'use strict';

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  function melbourneNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }));
  }
  function midnight(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addBiz(from, n) {
    var d = new Date(from.getTime()), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isBiz(d)) added++; }
    return d;
  }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function longFmt(d) { return d.getDate() + ' ' + FULL[d.getMonth()]; }
  function span(a, b) { return a.getTime() === b.getTime() ? fmt(a) : fmt(a) + ' - ' + fmt(b); }
  function two(n) { return n < 10 ? '0' + n : '' + n; }

  function render(el) {
    var type = el.getAttribute('data-type') || 'standard';
    var available = el.getAttribute('data-available') === 'true';
    if (!available && type !== 'preorder') { el.hidden = true; return; }

    var hMin = parseInt(el.getAttribute('data-handling-min'), 10); if (isNaN(hMin)) hMin = 0;
    var hMax = parseInt(el.getAttribute('data-handling-max'), 10); if (isNaN(hMax)) hMax = 1;
    var tMin = parseInt(el.getAttribute('data-transit-min'), 10) || 2;
    var tMax = parseInt(el.getAttribute('data-transit-max'), 10) || 5;
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour'), 10); if (isNaN(cutoff)) cutoff = 12;

    var now = melbourneNow();
    var today = midnight(now);
    var msg = el.querySelector('[data-ss-msg]');
    var d1 = el.querySelector('[data-ss-d1]');
    var d2 = el.querySelector('[data-ss-d2]');
    var d3 = el.querySelector('[data-ss-d3]');
    if (!msg || !d1 || !d2 || !d3) return;

    var readyMin, readyMax;

    if (type === 'preorder') {
      var raw = el.getAttribute('data-dispatch-date');
      if (!raw) { el.hidden = true; return; }
      var p = raw.split('-');
      readyMin = new Date(+p[0], +p[1] - 1, +p[2]);
      if (readyMin < today) { el.hidden = true; return; }
      readyMax = readyMin;
      msg.innerHTML = 'Please note that this is a pre-order, orders will be shipped by <strong>' +
        longFmt(readyMin) + '</strong> when stock arrives. Remember to order pre-order items ' +
        'separately if you need your other items delivered sooner!';
    } else {
      var before = now.getHours() < cutoff;
      var base = before ? today : addDays(today, 1);
      // dispatch window counts calendar days, the way the old app did
      readyMin = addDays(base, hMin);
      readyMax = addDays(base, hMax);

      var arriveA = addBiz(readyMin, tMin);
      var arriveB = addBiz(readyMax, tMax);

      if (hMax > 1) {
        msg.innerHTML = 'Dispatched in <strong>' + hMin + '-' + hMax + ' business days</strong>, ' +
          'and you’ll receive your package between <strong>' + fmt(arriveA) +
          ' and ' + fmt(arriveB) + '</strong>';
      } else {
        var word = before ? 'today' : 'tomorrow';
        var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0);
        if (!before) target.setDate(target.getDate() + 1);
        var ms = target - now;
        if (ms < 0) ms = 0;
        var hrs = Math.floor(ms / 3600000);
        var mins = Math.floor((ms % 3600000) / 60000);
        msg.innerHTML = 'Order within the next <strong>' + two(hrs) + 'h ' + two(mins) + 'm</strong> for ' +
          'dispatch <strong>' + word + '</strong>, and you’ll receive your package between <strong>' +
          fmt(arriveA) + ' and ' + fmt(arriveB) + '</strong>';
      }
    }

    d1.textContent = fmt(today);
    d2.textContent = span(readyMin, readyMax);
    d3.textContent = span(addBiz(readyMin, tMin), addBiz(readyMax, tMax));
    el.hidden = false;
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ss-edd]');
    for (var i = 0; i < nodes.length; i++) { render(nodes[i]); }
    setTimeout(boot, 30000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
